var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCheckCircleOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.5C13.1162 3.5 14.2217 3.7203 15.2529 4.14746C16.2841 4.57462 17.2215 5.20003 18.0107 5.98926C18.8 6.77849 19.4254 7.71591 19.8525 8.74707C20.2797 9.77834 20.5 10.8838 20.5 12C20.5 13.1162 20.2797 14.2217 19.8525 15.2529C19.4254 16.2841 18.8 17.2215 18.0107 18.0107C17.2215 18.8 16.2841 19.4254 15.2529 19.8525C14.2217 20.2797 13.1162 20.5 12 20.5C9.74566 20.5 7.58332 19.6048 5.98926 18.0107C4.3952 16.4167 3.5 14.2543 3.5 12C3.5 9.74566 4.3952 7.58332 5.98926 5.98926C7.58332 4.3952 9.74566 3.5 12 3.5Z",
    fill: "white",
    stroke: "#16BAB6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84375 11.9961L10.8687 14.0211L15.1437 9.74609",
    stroke: "#16BAB6",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircleOff);
export default __webpack_public_path__ + "static/media/icon_check_circle_off.e825b522.svg";
export { ForwardRef as ReactComponent };